<template lang="pug">
  section.contact#contacts
    yandex-map.map(:zoom="17", :coords="[55.774269, 37.674310]", :controls="[]", :detailed-controls="null", :scroll-zoom="false")
      ymap-marker(:coords="[55.774269, 37.674310]", :properties="properties", marker-type="placemark", marker-id="1")
    h2.container-fluid.title(v-if="lang==='ru'") Контакты
    h2.container-fluid.title(v-if="lang==='en'") Contacts
    .container-fluid(v-if="lang==='ru'")
      .contact__block
        ul.contact__list
          li.contact__item(v-for="(item, index) in contact1", :key="index")
            .contact__label {{ item.label }}
            .contact__value(v-if="item.label==='Адрес:'", :class="item.class") {{ item.value }}
            .contact__value(v-if="item.label==='Телефон'", :class="item.class")
              a(:href="item.vprefixed") {{ item.value }}
            .contact__value(v-if="item.label==='Почта'", :class="item.class")
              a(:href="item.vprefixed") {{ item.value }}
            .contact__value(v-if="item.label==='Коммерческий отдел'", :class="item.class")
              a(:href="item.vprefixed") {{ item.value }}
    .container-fluid(v-if="lang==='en'")
      .contact__block
        ul.contact__list
          li.contact__item(v-for="(item, index) in contact2", :key="index")
            .contact__label {{ item.label }}
            .contact__value(v-if="item.label==='Address:'", :class="item.class") {{ item.value }}
            .contact__value(v-if="item.label==='Phone'", :class="item.class")
              a(:href="item.vprefixed") {{ item.value }}
            .contact__value(v-if="item.label==='Email'", :class="item.class")
              a(:href="item.vprefixed") {{ item.value }}
            .contact__value(v-if="item.label==='Sales'", :class="item.class")
              a(:href="item.vprefixed") {{ item.value }}
</template>

<script>
  import { yandexMap, ymapMarker } from 'vue-yandex-maps'

  export default {
    name: 'contact',
    components: { yandexMap, ymapMarker },
    props: {
      lang: String
    },
    mounted() {

    },
    data() {
      return {
        properties: {
          iconContent: '<div class="circle-marker"></div>'
        },
        coords: [55.7515, 37.5295],
        contact1: [
          { label: 'Адрес:', value: '105066, Россия, г. Москва, ул. Нижняя Красносельская, д.39, стр. 1, этаж 3', class: null },
          { label: 'Телефон', value: '+ 7 495 775 03 05', vprefixed: 'tel:+74957750305', class: 'bold' },
          { label: 'Почта', value: 'info@newlogistic.com', vprefixed: 'mailto:info@newlogistic.com', class: 'bold' },
          { label: 'Коммерческий отдел', value: 'sales@newlogistic.com', vprefixed: 'mailto:sales@newlogistic.com', class: 'bold' }
        ],
        contact2: [
          { label: 'Address:', value: '39, building 1, 3rd floor, Nizhnyaya Krasnoselskaya st, Moscow, Russia, 105066', class: null },
          { label: 'Phone', value: '+ 7 495 775 03 05', vprefixed: 'tel:+74957750305', class: 'bold' },
          { label: 'Email', value: 'info@newlogistic.com', vprefixed: 'mailto:info@newlogistic.com', class: 'bold' },
          { label: 'Sales', value: 'sales@newlogistic.com', vprefixed: 'mailto:sales@newlogistic.com', class: 'bold' }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../style/variables";

  .contact {
    margin-top: 8vw;
    height: 57vw;
    position: relative;
    &__block {
      top: 10vw;
      right: 59vw;
      padding: 50px;
      width: 35vw;
      height: 32vw;
      position: absolute;
      background-color: $red-color;
      box-shadow: $shadow;
      z-index: 2;
    }
    &__list {
      margin: 0;
      padding: 0;
      color: white;
      list-style: none;
    }
    &__item {
      &:not(:last-child) {
        margin-bottom: 1.5vw;
      }
    }
    &__label {
      font-weight: 300;
      font-size: .9rem;
    }
    &__value {
      font-weight: 300;
      margin-top: .5vw;
      &.bold {
        font-size: 1.1rem;
        font-weight: 600;
      }
    }
  }

  .map {
    z-index: 1;
    height: 100%;
    position: relative;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
  }

  .container-fluid {
    top: 0;
    left: 0;
    z-index: 1;
    position: absolute;
  }

  .title {
    width: auto;
    display: inline-flex;
    color: $color-title-red;
    padding: 4.2vw $container-gutter-width 1.8vw;
  }

</style>

<style lang="scss">
  .circle-marker {
    $s: 3vw;
    margin-left: -($s / 3);
    margin-top: -($s / 3) + .5vw;
    background-color: red;
    width: $s;
    height: $s;
    border-radius: 50%;
    position: relative;
    &:after {
      $h: $s / 2;
      content: '';
      left: $h / 2;
      top: $h / 2;
      width: $h;
      height: $h;
      border-radius: 50%;
      background-color: white;
      position: absolute;
    }
  }
</style>
